var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.openNewTab}},[_c('div',{staticClass:"open-new-tab-button",class:{ disabled: _vm.disabled }},[_c('span',[_vm._t("default")],2),_c('i',{staticClass:"icons-external-link"})])])}
var staticRenderFns = []

export { render, staticRenderFns }